import store from '@/stores';

import { consultExit } from '@/utils/promoterAccess';

/**
 * A session on a former promoter reaches an operation screen through a bookmark,
 * the back button or a pasted link — the menu is filtered, the address bar is not.
 * The API refuses the operation either way; this only spares the operator a
 * screen that answers with an error to everything they try.
 *
 * Answers null while the user is unknown: `/users/me` lands after the first
 * navigation, and treating "not loaded yet" as read-only would bounce every
 * reload to the proposals list.
 *
 * `resolvePath` maps the landing to the path it ends on: a legacy redirect lands
 * elsewhere, and comparing the raw landing would bounce there forever.
 */
export function readOnlyRedirect(to, resolvePath = (path) => path) {
  const { userInfo } = store.state.user;

  if (!userInfo?.id) return null;

  return consultExit({
    userInfo, path: to.path, active: store.getters['user/isPromoterActive'], resolvePath,
  });
}
